import React from 'react'
import {
  StyleHowItWorkBottomContentWrapper,
  StyleHowItWorkBottomWrapper,
  StyleHowItWorkWrapper,
} from './style'
import { StyleText } from '@pages/front/commons/Text/style'
import numberTrail from './numberTrail.png'
import { StyleImage } from '@pages/front/Layout/Footer/style'
const HowItWorkArr = [
  {
    title: 'Find The Service You Need',
    subtitle:
      'You can find variety of Services on Supchar like Doctors, Lab test, Clinics, Medicine ordering and access to Health packages. Choose what you want.',
  },
  {
    title: 'Schedule or Get in touch Instantly',
    subtitle:
      'You can Schedule an appointment with doctor or if the doctor are available you can get instant access via Video consulting',
  },
  {
    title: 'Easy Access To Buying Medicine',
    subtitle:
      'You can upload image of your Prescription and the pharmacy near you will deliver your prescribed medicine to you.',
  },
  {
    title: 'Track Your Medical Report',
    subtitle:
      'You can keep track of all your medical reports and past interactions with the services you choose to engage with',
  },
]

const HowItWorks = () => {
  return (
    <StyleHowItWorkWrapper>
      <StyleText
        color="#262f77"
        fontSize="20"
        weight="600"
        style={{ textAlign: 'center' }}
      >
        How It Works?
      </StyleText>
      <img src={numberTrail} />
      <StyleHowItWorkBottomWrapper>
        {HowItWorkArr.map((item, i) => {
          return (
            <StyleHowItWorkBottomContentWrapper>
              <StyleText color="#262f77" fontSize="18">
                {item.title}
              </StyleText>
              <StyleText color="#414146" weight="400" fontSize="14">
                {item.subtitle}
              </StyleText>
            </StyleHowItWorkBottomContentWrapper>
          )
        })}
      </StyleHowItWorkBottomWrapper>
    </StyleHowItWorkWrapper>
  )
}

export default HowItWorks
